import { useEffect, useState } from "react"

//Assessments components
import { getFormulaFunctionList } from "./Helpers/formulaHelpers"

//PrimeReact
import { InputText } from "primereact/inputtext"

//Styles
import myStyles from "../../../../../styles/assessments/ManagementFormulaBuilder.module.css"
import RenderFormulaTag from "./RenderFormula/RenderFormulaTag"
import { classNames } from "primereact/utils"
import FormulaBuilderGroupingPanel from "./FormulaBuilderGroupingPanel"

export default function FormulaBuilderFunctions() {
  const functionList = getFormulaFunctionList()

  const [searchText, setSearchText] = useState("")
  const [functions, setFunctions] = useState(functionList)

  useEffect(() => {
    if (searchText) {
      const searchLower = searchText.toLowerCase()

      const newFunctionsList = functionList.filter((func) =>
        func.display.toLowerCase().includes(searchLower)
      )
      setFunctions(newFunctionsList)
    } else {
      setFunctions(functionList)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchText])

  return (
    <div
      className={classNames(
        myStyles.container,
        myStyles.groupingContainer,
        myStyles.formulaContainer
      )}
    >
      <FormulaBuilderGroupingPanel title="Functions">
        Choose a function and drag it onto the form to add it to the formula.
      </FormulaBuilderGroupingPanel>
      <div className={classNames(myStyles.container, myStyles.searchContainer)}>
        <span
          className="p-input-icon-left"
          style={{ flexGrow: "2", border: "none", width: "100%" }}
        >
          <i className="pi pi-search " />
          <InputText
            value={searchText}
            placeholder="Search"
            style={{ width: "100%", border: "none" }}
            onChange={(e) => {
              setSearchText(e.target.value)
            }}
          />
        </span>
      </div>
      {functions?.length > 0 ? (
        functions.map((functionItem) => (
          <RenderFormulaTag
            functionItem={functionItem}
            key={functionItem.name}
          />
        ))
      ) : (
        <>No functions found</>
      )}
    </div>
  )
}
